"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigKa = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
class BigKa extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.KA);
    }
}
exports.BigKa = BigKa;
